import { ReportSetting } from '../constants';
import { IReportSettingAction } from '../interfaces/actions';

export const setCustomer = (customerId: string): IReportSettingAction => ({ type: ReportSetting.SET, key: 'customerId', value: customerId });
export const setStartMs = (startMs: number): IReportSettingAction => ({ type: ReportSetting.SET, key: 'startMs', value: startMs });
export const setEndMs = (endMs: number): IReportSettingAction => ({ type: ReportSetting.SET, key: 'endMs', value: endMs });


// WEBPACK FOOTER //
// ./src/actions/ReportSetting.ts